import { all } from "redux-saga/effects";
import twilioChatSaga from "./twilio-chat";

export default function* rootSaga() {
  yield all([twilioChatSaga()]);
}
